/**
 * ToolRenderers Index
 *
 * Re-exports all tool renderer components for use in the chat interface.
 * Organized by domain for better maintainability.
 */
// Asset tools
import GetAvailableAssetsTool from './AssetTools';
// Chart tools
import { ChartBuilderTool, DisplayChartTool, GenerateChartTool } from './ChartTools';
// Database tools
import {
  DisplayCachedDataTool,
  GetColumnSummaryTool,
  GetRandomDataTool,
  GetRowRangeTool,
  ListCachedResultsKeysTool,
  QueryDatabaseTool,
} from './DatabaseTools';
// Generic/utility tools
import { GenericTool, TransferToAgentTool } from './GenericTools';
// Segment tools
import DisplaySegmentInsightsTool from './SegmentTools';
// Theme tools
import ExploreThemesTool from './ThemeTools';
// Verbatim tools
import { DisplayVerbatimTool, FindVerbatimsTool } from './VerbatimTools';

// Re-export for external use
export {
  GenerateChartTool,
  ChartBuilderTool,
  DisplayChartTool,
  QueryDatabaseTool,
  DisplayCachedDataTool,
  GetRandomDataTool,
  GetRowRangeTool,
  GetColumnSummaryTool,
  ListCachedResultsKeysTool,
  FindVerbatimsTool,
  DisplayVerbatimTool,
  ExploreThemesTool,
  GetAvailableAssetsTool,
  DisplaySegmentInsightsTool,
  GenericTool,
  TransferToAgentTool,
};

// Tool renderer mapping for chat interface
export const TOOL_RENDERERS = {
  query_database: QueryDatabaseTool,
  display_cached_data: DisplayCachedDataTool,
  get_random_data: GetRandomDataTool,
  get_row_range: GetRowRangeTool,
  get_column_summary: GetColumnSummaryTool,
  list_cached_results_keys: ListCachedResultsKeysTool,
  get_available_assets: GetAvailableAssetsTool,
  transfer_to_agent: TransferToAgentTool,
  generate_chart: GenerateChartTool,
  chart_builder: ChartBuilderTool,
  display_chart: DisplayChartTool,
  find_verbatims: FindVerbatimsTool,
  display_verbatim: DisplayVerbatimTool,
  explore_themes: ExploreThemesTool,
  display_segment_insights: DisplaySegmentInsightsTool,
};
